import { FC } from 'react'
import Svg, { Path, SvgProps } from 'react-native-svg'

const MealVoucherCardIcon: FC<SvgProps> = ({ fill, ...props }) => {
    const color = fill || 'currentColor'

    return (
        <Svg viewBox="0 0 32 32" width={20} height={20} fill="none" {...props}>
            <Path
                fill={color}
                d="M28.406 10.905v-.79c0-1.2-.98-2.18-2.18-2.18H5.856c-1.19 0-2.18.98-2.18 2.18v.79zM3.598 12.775v9.1c0 1.2.98 2.18 2.18 2.18h7.18V21.5h-1.58c-.14 0-.26-.12-.26-.26v-3.815c0-.77.22-1.45.67-2.02.45-.58 1.03-.97 1.74-1.16a.69.69 0 0 1 .63.14q.285.225.27.63v9.05h3.16v-3.4c-.51-.21-.94-.59-1.28-1.16s-.5-1.22-.49-1.95c0-.91.24-1.68.72-2.32.48-.63 1.07-.95 1.78-.95.7 0 1.29.32 1.77.95s.72 1.41.72 2.31c.02.74-.15 1.39-.49 1.95s-.77.95-1.29 1.16v3.4h7.11c1.2 0 2.18-.98 2.18-2.18v-9.1z"
            />
        </Svg>
    )
}

export default MealVoucherCardIcon
